module.exports = __webpack_public_path__ + "static/bg (3)-95d5b19c6901e54890824a3b6f640f20.jpg";